import { combineReducers } from 'redux';
import { showPageReducer } from './reducer/system/showPage';
import { storeReducer } from '../utilsTsx/reduxSaga/reducer/showPageReducer';
const rootReducer = combineReducers({
    showPageData: showPageReducer,
    pageStore: storeReducer
});

export default rootReducer;
